import { RecommendationMeResponse } from 'models/recommendationTool';
import { Client } from 'shared/api';

export function fetchRecommendationPersona(this: Client) {
  return this.network.get<RecommendationMeResponse>(`/recommendation-tool/me`);
}
